import React from "react";
import {Button, Col, Input, Row, Select} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {TICKET_CATEGORIES} from "constants/ticket";
import {getTopicOptions} from "./ticketTypeOptions";

export const TicketTypeFilters = ({filters, options, onChange, onAdd}) => {
    const {t} = useTranslation(["tickets"]);

    return (
        <Row gutter={[16, 16]} style={{marginBottom: 16}}>
            <Col xs={24} sm={12} md={6}>
                <Input
                    placeholder={t("ticketTypes.filters.name", {ns: "tickets"})}
                    value={filters.name}
                    onChange={e => onChange({name: e.target.value})}
                    allowClear
                />
            </Col>
            <Col xs={24} sm={12} md={6}>
                <Select
                    placeholder={t("ticketTypes.filters.category", {ns: "tickets"})}
                    value={filters.category}
                    onChange={value => onChange({category: value, topic: ""})}
                    style={{width: "100%"}}
                >
                    {TICKET_CATEGORIES.map(category => (
                        <Select.Option key={category} value={category}>
                            {t(`categories.${category}`, {ns: "tickets"})}
                        </Select.Option>
                    ))}
                </Select>
            </Col>
            <Col xs={24} sm={12} md={6}>
                <Select
                    placeholder={t("ticketTypes.filters.topic", {ns: "tickets"})}
                    value={filters.topic || undefined}
                    onChange={value => onChange({topic: value || ""})}
                    style={{width: "100%"}}
                    allowClear
                >
                    {getTopicOptions(options, filters.category).map(topic => (
                        <Select.Option key={topic.key} value={topic.key}>
                            {topic.name}
                        </Select.Option>
                    ))}
                </Select>
            </Col>
            <Col xs={24} sm={12} md={6} style={{textAlign: "right"}}>
                <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
                    {t("ticketTypes.add", {ns: "tickets"})}
                </Button>
            </Col>
        </Row>
    );
};
